// extracted by mini-css-extract-plugin
var _1 = "index_birdsBox__yVDSG";
var _2 = "index_menuList__AnnDb";
export { _1 as "birdsBox", _2 as "menuList" }
